export default __webpack_public_path__ + "static/media/whatsapp-notice-1.c14c2dc3.webp";